import React from "react";
import _ from "lodash";

import logo from "assets/images/say-what/saywhat-logo.png";

const SingleWinner = ({
  photo,
  caption,
  percentage,
  over_params,
  winnerName,
  userWon
}) => {
  const lost_text = _.get(over_params, "lost_text", "The Winner");
  const won_text_1 = _.get(over_params, "won_text_1", "YOU WON!");
  const won_text_2 = _.get(over_params, "won_text_2", "of the votes!");

  return (
    <div className="your-pick after-vote">
      <img src={logo} className="sw-logo" alt="logo" />
      <p className="txt">{userWon ? won_text_1 : lost_text}</p>
      <img src={photo} className="caption-img" alt="" />
      <p className="que">{`"${caption}"`}</p>
      <p className="by">{`by: ${userWon ? "YOU!" : winnerName}`}</p>
      <p className="wait-txt">{`${percentage}${won_text_2}`}</p>
    </div>
  );
};

export default SingleWinner;
